import '../snippets/product-gallery.js';
import '../components/back-in-stock.js';

function drawerSlider() {
    const $slideshow = $('.casousel-products-wrapper .products');

    $slideshow.slick({
        dots: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1
    });
}

$(document).ready(function() {
    drawerSlider();
});

$(window).resize(function(){
    drawerSlider();
});

$(document).on('ready', function(){
    $('#shopify-section-template_product').on('variantChange', function(e){
        if(e.variant) {
            $('[data-variant-sku]').html(e.variant.sku);
        }
    });
});
